/**
 * Hands "this session came from the login form" from the login page to the
 * analytics provider, so `user_logged_in` is captured right AFTER identify().
 *
 * Captured from the form itself, the event raced identify(): on Sep 28 some logins
 * landed on the browser's anonymous ID and showed no email in PostHog. A session
 * restored on page load never marks, so only real sign-ins count.
 */
let submitted = false
let failedAttempts = 0

export function markLoginSubmitted(): void {
  submitted = true
}

export function clearLoginSubmitted(): void {
  submitted = false
}

/** True once per marked login; clears the mark. */
export function consumeLoginSubmitted(): boolean {
  const was = submitted
  submitted = false
  // A marked login that reached identify() succeeded, so the failure streak ends.
  if (was) failedAttempts = 0
  return was
}

/** Failed sign-ins in a row in this tab, counting the one just recorded. */
export function nextLoginFailureAttempt(): number {
  failedAttempts += 1
  return failedAttempts
}

export function resetLoginFailureAttempts(): void {
  failedAttempts = 0
}
